import IconLock from 'assets/icons/icon-action-lock.svg?react'
import { FormattedMessage } from 'react-intl'
import RoundedIcon, { RoundedIconProps } from '../RoundedIcon'
import { ShareOptionLabelProps } from './ShareOptionLabel'

function PrivateIconLock(props: Omit<RoundedIconProps, 'icon'>) {
  return <RoundedIcon {...props} icon={<IconLock />} />
}

export const privateOptionDescriptor: ShareOptionLabelProps = {
  title: <FormattedMessage id="common.shareDialog.privateOption" />,
  isDefault: true,
  description: <FormattedMessage id="common.shareDialog.privateDesc" />,
  iconComponent: PrivateIconLock
}
